import styled from 'styled-components';
import theme from '../../theme/theme';

export const ResourceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 30px;
  // padding: 10px;
  font-family: 'Inter', sans-serif;

  &:hover {
    cursor: pointer;
  }
`;

export const Title = styled.h2`
  font-size: 15px;
  font-weight: 700;
  padding: 0 7px;
`;

export const Description = styled.p`
  font-size: 13px;
  font-weight: 400;
  color: #7B7A7A;
  margin-top: -10px;
  padding: 0 7px;
  // overflow-wrap: break-word;
  // word-wrap: break-word;
  // hyphens: auto;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Location = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 7px;
  margin-top: -5px;
`;

export const LocationText = styled.p`
  font-size: 13px;
  font-weight: 500;
  color: ${theme.color.black};
  margin: 0px;
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  margin: 0 5px;
`;
